import { render, staticRenderFns } from "./manage-Trainings-table.vue?vue&type=template&id=3b7e9cbf&"
import script from "./manage-Trainings-table.vue?vue&type=script&lang=js&"
export * from "./manage-Trainings-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports